import React from 'react';
import { BarraOferta } from './components/BarraOferta';
import { Hero } from './components/Hero';
import { Proceso } from './components/Proceso';
import { ProyectosCarrusel } from './components/ProyectosCarrusel';
import { Identificacion } from './components/Identificacion';
import { Metodo } from './components/Metodo';
import { Videos } from './components/Videos';
import { PlantillasCarrusel } from './components/PlantillasCarrusel';
import { Bonos } from './components/Bonos';
import { Testimonios } from './components/Testimonios';
import { Oferta } from './components/Oferta';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="w-full bg-crema font-sans" data-id="element-0" data-mp="2whx8rm2ytac0">
      <MetaPixel data-id="element-1" data-mp="28tmfp53igeya" />
      <BarraOferta data-id="element-2" data-mp="28t4lee0esat0" />

      <main className="w-full" data-id="element-3" data-mp="28sl511qepuh3">
        <Hero data-id="element-4" data-mp="23vcmh01cjofb" />
        <Proceso data-id="element-5" data-mp="23vuoyeelqyvo" />
        <ProyectosCarrusel data-id="element-6" data-mp="23u9vks40xlze" />
        <Identificacion data-id="element-7" data-mp="23v2tr4ox335x" />
        <Metodo data-id="element-8" data-mp="3ijxqiu0iq6lh" />
        <Videos data-id="element-9" data-mp="3ikh7o8icgqyg" />
        <PlantillasCarrusel data-id="element-10" data-mp="3iiwdwl3utc1n" />
        <Bonos data-id="element-11" data-mp="3ijpcgysnsv8p" />
        <Testimonios data-id="element-12" data-mp="3ii4t85bsoyq5" />
        <Oferta data-id="element-13" data-mp="3mlaxx8j9ehui" />
        <Faq data-id="element-14" data-mp="3mkrefndynled" />
      </main>

      <Footer data-id="element-15" data-mp="3mjzs7369700r" />
    </div>;
}